import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "./store/actions/products-actions";
import { AnimatePresence } from "framer-motion";

import Home from "./pages/Home";
import Hero from "./pages/Hero";
import NotFound from "./pages/NotFound";
import MainNavigation from "./layout/MainNavigation";
import Footer from "./layout/Footer";
import ChatBot from "./components/home/ChatBot";
import HomeRedirect from "./components/auth/HomeRedirect";
import { AuthProvider } from "./components/context/AuthContext";
import Reservas from "./pages/Reservas";
import Viajes from "./pages/Viajes";
import Proyectos from "./pages/Proyectos";
import About from "./pages/About";
import Consultas from "./pages/AdminConsultas";
import AdminViajes from "./pages/AdminViajes";
import Mentorias from "./pages/Mentorias";
import AdminMentorias from "./pages/AdminMentorias";
import AdminAgenteIA from "./pages/AdminIA";
import AdminMetaPixel from "./pages/AdminMeta";

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAdmin = useSelector((state) => state.auth.isAdmin);

  // 👇 estado global para controlar modales
  const [modalAbierto, setModalAbierto] = useState(false);

  useEffect(() => {
    dispatch(getProducts());
  }, [dispatch]);

  const isLanding = location.pathname === "/metodo-alma";

  return (
    <AuthProvider>
      {/* NAV — la landing /metodo-alma trae su propio header, así que no lo duplicamos */}
      {!isAdmin && !isLanding && <MainNavigation />}

      {/* ROUTES */}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route element={<HomeRedirect />}>
            <Route path="/" element={<Hero />} />
            <Route path="/metodo-alma" element={<Home />} />
            <Route path="/destinos" element={<Viajes />} />
            <Route path="/reservas" element={<Reservas />} />
            <Route path="/mi-vision" element={<About />} />
            <Route path="/mentorias" element={<Mentorias />} />
            <Route path="/admin-agente-ia" element={<AdminAgenteIA />} />
            <Route path="/admin-meta" element={<AdminMetaPixel />} />

            {/* 👇 le pasamos el control del modal */}
            <Route
              path="/admin-consultas"
              element={<Consultas setModalAbierto={setModalAbierto} />}
            />
<Route
              path="/admin-viajes"
              element={<AdminViajes/>}
            />
                        <Route path="/admin-mentorias" element={<AdminMentorias />} />

            <Route path="/proyectos" element={<Proyectos />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>

      {/* CHATBOT — visible en todas las vistas, salvo el panel admin */}
      {!isAdmin && <ChatBot />}

      {/* FOOTER */}
      {!isAdmin && !modalAbierto && <Footer />}
    </AuthProvider>
  );
};

export default App;